import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, dashboardFor } from './auth';
import { Loader2 } from 'lucide-react';

export default function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#0c0a08] text-white">
      <Loader2 className="w-6 h-6 animate-spin" />
    </div>
  );
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} state={{ from: loc }} replace />;
  // Members are never allowed into admin routes
  if (user.role === 'member') return <Navigate to={dashboardFor(user.role)} replace />;
  // role-gated routes: admin role required (advisors can't access admin-only screens like settings/types)
  if (role === 'admin' && user.role !== 'admin') return <Navigate to="/admin" replace />;
  return children;
}
